module.exports = __webpack_public_path__ + "img/flow.15960057.png";